/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "लोड हो रहा है"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var hiIN = Object.assign(TranslationProviderComponent, {
  translations
});

export { hiIN as h };
//# sourceMappingURL=hi-IN-Do80IQmX.js.map
